var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTag(_ref, svgRef) {
  var _ref2, _ref3;

  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.7229 3.19391C13.1135 2.80318 13.6433 2.58361 14.1958 2.5835H21.6667C22.2192 2.5835 22.7491 2.80299 23.1398 3.19369C23.5305 3.58439 23.75 4.1143 23.75 4.66683V12.1377C23.7499 12.6902 23.5303 13.22 23.1396 13.6106L14.0729 22.6772C13.5995 23.1477 12.9591 23.4118 12.2917 23.4118C11.6242 23.4118 10.9839 23.1477 10.5104 22.6772L3.65625 15.8231C3.18578 15.3496 2.92173 14.7093 2.92173 14.0418C2.92173 13.3744 3.18578 12.734 3.65625 12.2606L12.7229 3.19391Z",
    stroke: "#1A4338",
    style: (_ref2 = {
      stroke: "#1A4338"
    }, _defineProperty(_ref2, "stroke", "color(display-p3 0.1020 0.2627 0.2196)"), _defineProperty(_ref2, "strokeOpacity", 1), _ref2),
    strokeWidth: 1.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0202 8.83366C17.7325 8.83366 17.4993 8.60047 17.4993 8.31283C17.4993 8.02518 17.7325 7.79199 18.0202 7.79199C18.3078 7.79199 18.541 8.02518 18.541 8.31283C18.541 8.60047 18.3078 8.83366 18.0202 8.83366Z",
    fill: "#1A4338",
    stroke: "#1A4338",
    style: (_ref3 = {
      fill: "#1A4338"
    }, _defineProperty(_ref3, "fill", "color(display-p3 0.1020 0.2627 0.2196)"), _defineProperty(_ref3, "fillOpacity", 1), _defineProperty(_ref3, "stroke", "#1A4338"), _defineProperty(_ref3, "stroke", "color(display-p3 0.1020 0.2627 0.2196)"), _defineProperty(_ref3, "strokeOpacity", 1), _ref3),
    strokeWidth: 1.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.3321cadf.svg";
export { ForwardRef as ReactComponent };